
import { Button } from "@/components/ui/button";
import { useTranslatedText } from "@/hooks/useTranslate";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const CallToActionSection = () => {
  const navigate = useNavigate();
  const titleText = useTranslatedText("¿Listo para transformar tu presencia digital?");
  const subtitleText = useTranslatedText("Convierte tu visión en realidad con soluciones tecnológicas de clase mundial.");
  const ctaText = useTranslatedText("Comencemos tu proyecto");

  return (
    <section className="py-24 relative overflow-hidden">
      {/* Vibrant gradient background */}
      <div className="absolute inset-0 bg-gradient-to-br from-techno-dark via-[#1a1145] to-techno-dark"></div>
      
      {/* Animated orbs */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/2 left-1/4 w-64 h-64 bg-techno-purple/20 rounded-full blur-3xl animate-float"></div>
        <div className="absolute bottom-1/4 right-1/3 w-80 h-80 bg-techno-accent/15 rounded-full blur-3xl animate-float" style={{ animationDelay: '2s' }}></div>
      </div>

      {/* Grid overlay */}
      <div className="absolute inset-0 hero-grid opacity-30"></div>

      <div className="container mx-auto px-4 relative z-10 text-center">
        <div className="max-w-3xl mx-auto space-y-8">
          <h2 className="text-4xl lg:text-6xl font-bold text-white leading-tight" style={{ animation: 'slide-up 0.6s ease-out' }}>
            {titleText}
          </h2>
          <p className="text-xl text-gray-300 leading-relaxed" style={{ animation: 'slide-up 0.6s ease-out 0.2s both' }}>
            {subtitleText}
          </p>
          <div style={{ animation: 'slide-up 0.6s ease-out 0.4s both' }}>
            <Button
              size="lg"
              className="bg-button-gradient hover:opacity-90 transition-all duration-300 pulse-glow text-lg px-10 py-6 rounded-xl group"
              onClick={() => navigate('/contacto')}
            >
              {ctaText}
              <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallToActionSection;
